import clsx from 'clsx';

type Props = {
  userType: string;
  status?: string;
};

export default function UserTypeTag({ userType, status }: Props) {
  // 招待中の場合は招待中ラベルを優先表示
  if (status === 'invite') {
    return (
      <span className="inline-block rounded-full bg-[#FFF4E6] px-3 py-[6px] text-xs whitespace-nowrap text-[#D97706]">
        招待中
      </span>
    );
  }

  return (
    <span
      className={clsx(
        'inline-block rounded-full px-3 py-[6px] text-xs whitespace-nowrap text-[#0E295D]',
        userType === 'admin' ? 'bg-[#EEE9FE]' : 'bg-[#D6EEFF]'
      )}
    >
      {userType === 'admin' ? '管理者' : '通常'}
    </span>
  );
}
